import React from 'react';
import PropTypes from "prop-types";
import { t } from 'translates';
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import Icon from "../../../common/components/Icon";

const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

const SessionItem = ({ product }) => {
  const {
    title,
    image,
    category_name,
    sessions_data: {
      available_label,
      is_available,
      language,
      time,
      date,
    },
    description,
    url,
    color,
    price_string,
    tracking,
  } = product;

  const handleClickGTM = () => {
    window.dataLayer && window.dataLayer.push({
      'event': 'select_item',
      'ecommerce': {
        'currency': tracking.currency_code,
        'items': [{
          'item_id': tracking.id,
          'item_name': tracking.title,
          'item_category': tracking.category_name,
          'item_available': tracking.is_available,
          'price': tracking.price,
          'item_type': tracking.category_type,
          'index': 0,
          item_list_name: 'N/A',
          item_list_id: pg_type + ' - N/A - ' + window.location.pathname,
        }]
      }
    });

    storage.set('analytics.' + tracking.id, {
      'pg_type': pg_type,
      'item_list_name': 'N/A',
      'url': window.location.pathname,
      'index': 0,
      'timestamp': Date.now()
    });
  }

  const handleAuxClick = (event) => {
    if (event.button === 1) {
      handleClickGTM();
    }
  }

  return (
    <div className="session-new session-new--product">
      <div className="session-new__header">
        <div className="cart-new-item__label"
          style={{
            backgroundColor: color,
          }}
        >
          {category_name}
        </div>
        <div className="session-new__image">
          <LazyLoadImageComponent
            src={image.uri}
            alt={image.alt}
          />
        </div>
      </div>
      <div className="session-new__content">
        <div className="session-new__body">
          <h3 className="session-new__title">
            {title}
          </h3>
          <div
          className="session-new__subtitle">
            <div className="session-new__session-info">
              {`${t('Next session', DT_CART)}: ${date} — ${time} ${language}`}
            </div>
            {is_available && (
              <a href={url} className="session-new__available-sessions" onClick={handleClickGTM} onAuxClick={handleAuxClick}>
                {available_label}
              </a>
            )}
          </div>
          <div className="session-new__description">
            {description}
          </div>
        </div>
        <div className="session-new__footer">
          <a href={url} className="session-new__btn" onClick={handleClickGTM} onAuxClick={handleAuxClick}>
            {t('Book now', DT_CART)}
          </a>
          <div className="session-new__price">
            <Icon name="price-mobile" />{price_string.split(' ')[1]}{price_string.split(' ')[0]}
          </div>
        </div>
      </div>
    </div>
  );
};

SessionItem.propTypes = {
  product: PropTypes.object.isRequired,
}

export default SessionItem;
